export default __webpack_public_path__ + "static/media/BUTTERCUP.3225d993.svg";